export function isNull<T>(value: T | null): value is null {
  return value === null;
}

export function assertIsNull<T>(value: T | null): asserts value is null {
  if (isNotNull(value)) {
    throw new TypeError(`Value is not null.`);
  }
}

export function isNotNull<T>(value: T | null): value is T {
  return value !== null;
}

export function assertIsNotNull<T>(value: T | null): asserts value is T {
  if (isNull(value)) {
    throw new TypeError(`Value is null.`);
  }
}
